module.exports = __webpack_public_path__ + "static/media/icon.782f7b14.svg";